export default "__VITE_ASSET__DKDy5mBn__"